module.exports = __webpack_public_path__ + "static/media/homem-aranha@2x.9c3a91b1.png";